import { Div, RefString, CollectionPrinter, TextInput, Button } from "@tblabs/truffle";
import { Chat } from "../Services/Chat";
import { MessageBox } from "../Components/MessageBox";


export class ChatView extends Div
{
	constructor(_chat: Chat)
	{
		super("chat-container");

		const msg = new RefString();

		this.Append(
			new Div("chat-messages").Append(
				new CollectionPrinter(_chat.Messages, entry =>
				{
					const isOwnerOfThisMessage = entry.Author.value == _chat.User.Name;

					return new MessageBox(isOwnerOfThisMessage ? "sent" : "received", entry);
				})
			),
			new Div("chat-input").Append(
				new TextInput(msg).Placeholder(`Napisz wiadomość jako ${_chat.User.Name}...`),
				new Button("Wyślij").RemoveAllClasses()
					.EnableWhen(msg, msg => msg.length > 0)
					.OnClick(async () =>
					{
						const text = msg.value;
						msg.value = "";
						await _chat.AddMessage(text);
					})
			)
		);
	}
}
